
































import { Component, Prop, Vue } from 'vue-property-decorator';

import AdminService from '@/api/AdminService';

import { treatError } from '@/utils';
import { toNumber, treatValue } from '@/utils/moneyTreatments';
import eventBus from '@/utils/eventBus';

import HTTPStatus from '@/constants/httpStatus';

import Container from '@/components/atoms/Grid/Container.vue';
import Subtitle from '@/components/molecules/Typography/Subtitle.vue';
import Description from '@/components/molecules/Typography/Description.vue';
import FormLabel from '@/components/molecules/Typography/FormLabel.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import SelectorAndList from '@/components/organisms/Views/admin/flags/SelectorAndList.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import TextField from '@/components/atoms/TextField/TextField.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import CoinStoreDealsList from '@/components/organisms/CoinStore/CoinDealsList/CoinDealsList.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import DealForm, { EDealType } from './DealForm.vue';

type DealFormData = {
  coins: number;
  value: number;
  twismCoin: number;
  merchantCoin: number;
  dealType: EDealType | null;
};

@Component({
  components: {
    FilledButton,
    FormLabel,
    Description,
    Subtitle,
    Container,
    Checkbox,
    SelectorAndList,
    TextField,
    Typography,
    SideModalHeader,
    CoinStoreDealsList,
    DealForm
  }
})
export default class CoinStoreDealsManager extends Vue {
  @Prop() readonly data!: any;

  loading = false;
  adminService = new AdminService();

  get coinsAvailable() {
    return treatValue(toNumber(this.data.coinsAvailable));
  }

  handleSubmit(formData: DealFormData) {
    const onConfirm = async () => {
      this.loading = true;

      try {
        const { status } = await this.adminService.createCoinDeal({
          coinStoreId: this.data.coinStoreId,
          coins: formData.coins,
          value: formData.value,
          dealType: formData.dealType,
          ...(formData.dealType === EDealType.DUO_COIN_DEAL && {
            twismCoin: formData.twismCoin,
            merchantCoin: formData.merchantCoin
          })
        });

        if (status !== HTTPStatus.CREATED) return;

        this.$notification('Coin deal created successfully');

        eventBus.$emit('reloadCoinStore');
        eventBus.$emit('closeModal');
        eventBus.$emit('reloadCoinDealsList');
        eventBus.$emit('resetDealForm');
      } catch (e) {
        treatError(e);
      } finally {
        this.loading = false;
      }
    };

    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        componentToRender: 'coinStoreDealConfirmModal',
        hideCancelButton: false,
        icon: '',
        mobilePositionBottom: true,
        mobileFullScreen: false
      }),
      {
        data: {
          coins: formData.coins
        },
        title: `Are you sure?`,
        subtitle: `A deal of ${formData.coins} Coins for $${
          formData.value
        } will be created`,
        onConfirm
      }
    );
  }

  closeModal() {
    if (this.data.close) {
      this.data.close();
    }
  }
}
